/**
 * `requestIdleCallback` and `cancelIdleCallback` polyfills.
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback
 *
 * @src       https://gist.github.com/paullewis/55efe5d6f05434a96c36
 * @author    Nik Yusof <nyusof@wayfair.com>
 * @copyright 2020 Wayfair LLC - All rights reserved
 */
/* eslint-disable no-undef */
if (typeof window !== 'undefined') {
  window.requestIdleCallback =
    window.requestIdleCallback ||
    function(callback) {
      return setTimeout(() => {
        const start = Date.now();
        callback({
          didTimeout: false,
          timeRemaining() {
            return Math.max(0, 50 - (Date.now() - start));
          },
        });
      }, 1);
    };

  window.cancelIdleCallback =
    window.cancelIdleCallback ||
    function(id) {
      clearTimeout(id);
    };
}
